import { render, staticRenderFns } from "./BoxDemographicMetrics.vue?vue&type=template&id=6535ef36&scoped=true&"
import script from "./BoxDemographicMetrics.vue?vue&type=script&lang=js&"
export * from "./BoxDemographicMetrics.vue?vue&type=script&lang=js&"
import style0 from "./BoxDemographicMetrics.vue?vue&type=style&index=0&id=6535ef36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6535ef36",
  null
  
)

export default component.exports
import {QCard,QIcon,QCardSection,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QIcon,QCardSection,QInnerLoading,QSpinnerTail})
